import { useSearchParams } from 'react-router-dom';

export const useChannelFromUrl = (): {
  channelIdFromUrl: string | undefined;
} => {
  const [searchParams] = useSearchParams();

  const getChannelIdFromUrl = () => {
    return searchParams.get('channelId') || undefined;
  };

  return {
    channelIdFromUrl: getChannelIdFromUrl(),
  };
};
